<template>
  <div
    class="mobile-pull-refresh-indicator"
    :class="{ visible: indicatorVisible, refreshing }"
    :style="indicatorStyle"
    aria-hidden="true"
  >
    <span class="mobile-pull-refresh-ring" :style="ringStyle"></span>
  </div>
</template>

<script>
export default {
  name: 'MobilePullRefreshIndicator',
  props: {
    distance: {
      type: Number,
      default: 0
    },
    refreshing: {
      type: Boolean,
      default: false
    },
    threshold: {
      type: Number,
      default: 88
    },
    holdHeight: {
      type: Number,
      default: 64
    }
  },
  computed: {
    indicatorVisible() {
      return this.refreshing || this.distance >= this.threshold
    },
    indicatorHeight() {
      return this.indicatorVisible ? this.holdHeight : 0
    },
    pullProgress() {
      const threshold = Math.max(1, Number(this.threshold) || 1)
      return Math.min(1, Math.max(0, this.distance / threshold))
    },
    indicatorStyle() {
      return {
        height: `${this.indicatorHeight}px`
      }
    },
    ringStyle() {
      if (this.refreshing) {
        return null
      }
      return {
        opacity: .35 + this.pullProgress * .65,
        transform: `rotate(${this.pullProgress * 300}deg)`
      }
    }
  }
}
</script>

<style scoped>
.mobile-pull-refresh-indicator {
  width: 100%;
  height: 0;
  min-height: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  pointer-events: none;
  box-sizing: border-box;
  transition: height .18s ease;
}

.mobile-pull-refresh-indicator.visible {
  overflow: visible;
}

.mobile-pull-refresh-ring {
  width: 22px;
  height: 22px;
  border: 2px solid rgba(39, 91, 82, .2);
  border-top-color: #275b52;
  border-right-color: #275b52;
  border-radius: 50%;
  display: block;
  box-sizing: border-box;
  transform-origin: center;
}

.mobile-pull-refresh-indicator.refreshing .mobile-pull-refresh-ring {
  animation: mobile-pull-refresh-ring 720ms linear infinite;
}

@keyframes mobile-pull-refresh-ring {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .mobile-pull-refresh-indicator,
  .mobile-pull-refresh-indicator.refreshing .mobile-pull-refresh-ring {
    transition: none;
    animation-duration: 1.4s;
  }
}
</style>
